<template>
    <div class="form-feed">
        <div class="gcmcn-form-title">
            {{ feedResource === null ? 'Add' : 'Update' }} feed resource
        </div>
        <div v-if="formInitialised" class="gcmcn-card form-feed">
            <el-form :model="form" :rules="rules" ref="form">
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-6">
                        <el-form-item class="gcmcn-form-input" prop="display_name">
                            <div class="gcmcn-form-label">Name</div>
                            <el-input
                                v-model="form.display_name"
                                size="mini"
                                :disabled="feedResource !== null"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="delivery_aws_regions_uid">
                            <div class="gcmcn-form-label">Aws Regions</div>
                            <el-select
                                v-model="form.delivery_aws_regions_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder="Select regions"
                                multiple
                                filterable
                                collapse-tags
                            >
                                <RegionOption
                                    v-for="region in awsregionsSortedByName"
                                    :key="region.uid"
                                    :region="region"
                                    :feed-resource="feedResource"
                                    :feed-resource-configurations="feedResourceConfigurations"
                                    :current-regions="form.delivery_aws_regions_uid"
                                ></RegionOption>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input" prop="universe_uid">
                            <div class="gcmcn-form-label">Universe</div>
                            <el-select
                                v-model="form.universe_uid"
                                popper-class="gcmcn-popper"
                                size="mini"
                                placeholder="Select a universe"
                                :disabled="feedResource !== null"
                                @change="setEntityUid"
                            >
                                <el-option
                                    v-for="universe in availableUniverses"
                                    :key="universe.uid"
                                    :label="universe.display_name"
                                    :value="universe.uid"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <el-form-item
                    class="gcmcn-form-input radio-input"
                >
                    <div class="gcmcn-form-label">Choose redundancy</div>
                    <el-radio
                        v-model="form.redundancy_type"
                        :disabled="feedResource !== null"
                        label="1+0"
                    >
                        1+0 (MAIN only)
                    </el-radio>
                    <el-radio
                        v-model="form.redundancy_type"
                        :disabled="feedResource !== null"
                        label="1+1"
                    >
                        1+1 (MAIN+BACKUP)
                    </el-radio>
                </el-form-item>
                <div class="gcmcn-inputs-container">
                    <div class="flex-basis-10">
                        <el-form-item class="gcmcn-form-input">
                            <div class="gcmcn-form-label" style="margin-bottom: 15px;">Description</div>
                            <el-input
                                type="textarea"
                                style="display: block;"
                                :rows="4"
                                size="mini"
                                v-model="form.description"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >
                        Cancel
                    </el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >
                        Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RegionOption from './region-option.vue'
export default {

    name: 'FeedResourceForm',
    components:{
        RegionOption,
    },
    props:{
        universes:{
            type: Array,
            required: true,
        },
        feedResource:{
            type: Object,
            required: false,
            default: ()=>{return null;}
        },
        feedResourceConfigurations:{
            type: Array,
            required: false,
            default: ()=>{return [];}
        },
    },
    data () {
        return {
            formInitialised: false,
            loading: false,
            form:{
                name: '',
                display_name: '',
                entity_uid: '',
                universe_uid:'',
                redundancy_type: '1+1',
                description: '',
                delivery_aws_regions_uid: [],
            },
            rules:{
                display_name: [
                    { required: true, validator: this.authorizedCharacters }
                ],
                entity_uid: [{ required: true }],
                universe_uid: [{ required: true }],
            }
        };
    },
    computed:{
        ...mapGetters([
            'administrableEntitiesUids',
            'userIsEntityAdmin',
            'awsregionsSortedByName',
        ]),
        availableUniverses(){
            if(this.userIsEntityAdmin()){
                return this.universes.filter(
                    universe => this.administrableEntitiesUids.includes(universe.scopes.entity_uid)
                );
            }
            return this.universes;
        }
    },
    mounted(){
        this.setForm();
    },
    methods:{
        setEntityUid(universeUid){
            let universe = this.universes.find(universe => universe.uid === universeUid);
            if(universe){
                this.$set(this.form, 'entity_uid', universe.scopes.entity_uid);
            }
        },
        setForm (){
            if(this.feedResource){
                this.$set(
                    this,
                    'form',
                    JSON.parse(JSON.stringify(this.feedResource))
                );
                this.$set(
                    this.form,
                    'entity_uid',
                    this.feedResource.scopes.entity_uid
                );
            }else{
                this.$set(this, 'form', {
                    name: '',
                    display_name: '',
                    entity_uid: '',
                    universe_uid:'',
                    redundancy_type: '1+1',
                    description: '',
                    delivery_aws_regions_uid: [],
                });
            }
            this.formInitialised = true;
        },
        authorizedCharacters(rule, value, callback) {
            if(!this.form.display_name) {
                return callback(new Error('Name is required'));
            } else if (
                !this.form.display_name.match(
                    this.$store.getters.authorizedCharactersRegex
                )
            ){
                return callback(new Error('Invalid name'));
            } else {
                callback();
            }
        },
        leave(){
            this.$emit('leave-form-view');
        },
        validateForm(){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let postData = {
                        item:{...this.form},
                        model: 'feedResources',
                        scopes: {'X-Entity-Uid': this.form.entity_uid},
                    };
                    let action = 'createItem';
                    let messageType = 'create';
                    if(this.feedResource){
                        action = 'patchItem';
                        messageType = 'update';
                    }else{
                        postData.item.name = postData.item.display_name;
                        postData.url = this.$store.state.api.meta.listModels.feedResources.url;
                        delete postData.item.entity_uid;
                    }
                    this.$store.dispatch(action, postData)
                    .then((res) => {
                        this.$message({
                            message: `Feed resource ${messageType}d!`,
                            type: 'success'
                        });
                        this.loading = false;
                        this.$emit('feed-resource-created');
                    })
                    .catch(e=>{
                        this.$message.error(
                            `Error on feed resource ${messageType === 'update' ? messageType : 'creation'}.`
                        );
                        this.loading = false;
                    });
                }
            });
        },
    }
};
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feed-resource-form.vue